"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var index_1 = require("../../index");
var Messages = require("../../codegen/Messages");
var HeaderWithTooltip = function (_a) {
    var children = _a.children, tooltipContent = _a.tooltipContent, testId = _a.testId;
    var buttonRef = React.useRef(undefined);
    var clickHandler = function (event) {
        if (buttonRef.current && buttonRef.current.contains(event.target)) {
            // prevent sorting when clicking on the Info Icon
            event.stopPropagation();
        }
    };
    var keyDownHandler = function (event) {
        if (event.key === " " || event.key === "Enter") {
            var clickEvent = new MouseEvent("click", {
                bubbles: false,
                view: window
            });
            event.preventDefault();
            event.stopPropagation();
            event.target.dispatchEvent(clickEvent);
        }
    };
    var tooltipElement = (React.createElement("span", { className: "oui-margin-small-left oui-margin-small-bottom" },
        React.createElement(index_1.Button, { buttonStyle: index_1.ButtonStyle.Link, onClick: clickHandler, onKeyDown: keyDownHandler, ref: buttonRef, type: index_1.ButtonType.Button },
            React.createElement(index_1.IconElement, { label: Messages.Common.moreInfo(), ariaLabel: Messages.Common.moreInfo(), icon: index_1.Icon.Info })),
        React.createElement(index_1.Tooltip, { testId: testId },
            React.createElement("span", { className: "oui-tooltip-lite" }, tooltipContent))));
    return (React.createElement("div", { className: "oui-display-inline-block oui-text-top" },
        children,
        tooltipElement));
};
exports.default = HeaderWithTooltip;
//# sourceMappingURL=HeaderWithTooltip.js.map